// frontend/src/services/api/creditAPI.js
import api from "./index";

const creditAPI = {
  getBalance: () => api.get("/credits/balance"),
};

export default creditAPI;
